import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBezierEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBezierEdit"><Path fillRule="evenodd" clipRule="evenodd" d="M16.7929 13.4596C17.8278 12.4247 19.5056 12.4247 20.5404 13.4596C21.5753 14.4944 21.5753 16.1722 20.5404 17.2071L16.7475 21H13V17.2524L16.7929 13.4596Z" fill="currentColor"/><Path d="M3 3V9H5V15H3V21H9V19H11V17H9V15H7V9H9V7H15V9H17V10H19V9H21V3H15V5H9V3H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBezierEdit;
